<template>
  <page :load="init">
    <form>
      <message :messages="messages"></message>
      <v-card>
        <v-tabs v-model="tabMenu">
          <v-tabs-slider color="primary"></v-tabs-slider>
          <v-tab>Backend Users</v-tab>
          <v-tab>Members</v-tab>
          <v-tab-item>
            <v-card-text>
              <v-layout row wrap>
                <v-flex lg4 xs12>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-checkbox data-vv-scope="acctForm" v-model="acctForm.usr2FA" :error-messages="errors.collect('acctForm.usr2FA')" data-vv-name="usr2FA" :data-vv-as="labels.usr2FA" :label="labels.usr2FA"></v-checkbox>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field data-vv-scope="acctForm" v-int-mask="{intScale: 4}" v-model="acctForm.usrDormant" :label="labels.usrDormant" type="tel" :error-messages="errors.collect('acctForm.usrDormant')" data-vv-name="usrDormant" :data-vv-as="labels.usrDormant" v-validate="'required|numeric|max_value:9999|min_value:0'"></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field data-vv-scope="acctForm" v-int-mask="{intScale: 4}" v-model="acctForm.usrLoginAttempt" :label="labels.usrLoginAttempt" type="tel" :error-messages="errors.collect('acctForm.usrLoginAttempt')" data-vv-name="usrLoginAttempt" :data-vv-as="labels.usrLoginAttempt" v-validate="'required|numeric|max_value:9999|min_value:0'"></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field data-vv-scope="acctForm" v-int-mask="{intScale: 8}" v-model="acctForm.usrLoginBanDuration" :label="labels.usrLoginBanDuration" type="tel" :error-messages="errors.collect('acctForm.usrLoginBanDuration')" data-vv-name="usrLoginBanDuration" :data-vv-as="labels.usrLoginBanDuration" v-validate="'required|numeric|max_value:99999999|min_value:0'"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions class="ma-2">
              <v-btn color="primary" :loading="loading" @click.prevent="doUpdateCheck" type="submit">
                Update
                <v-icon right>mdi-content-save</v-icon>
              </v-btn>
            </v-card-actions>
          </v-tab-item>
          <v-tab-item>
            <v-card-text>
              <v-layout row wrap>
                <v-flex lg4 xs12>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field data-vv-scope="memberAcctForm" v-int-mask="{intScale: 4}" v-model="memberAcctForm.membDormant" :label="labels.membDormant" type="tel" :error-messages="errors.collect('memberAcctForm.membDormant')" data-vv-name="membDormant" :data-vv-as="labels.membDormant" v-validate="'required|numeric|max_value:9999|min_value:0'"></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field data-vv-scope="memberAcctForm" v-int-mask="{intScale: 4}" v-model="memberAcctForm.membLoginAttempt" :label="labels.membLoginAttempt" type="tel" :error-messages="errors.collect('memberAcctForm.membLoginAttempt')" data-vv-name="membLoginAttempt" :data-vv-as="labels.membLoginAttempt" v-validate="'required|numeric|max_value:9999|min_value:0'"></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field data-vv-scope="memberAcctForm" v-int-mask="{intScale: 8}" v-model="memberAcctForm.membLoginBanDuration" :label="labels.membLoginBanDuration" type="tel" :error-messages="errors.collect('memberAcctForm.membLoginBanDuration')" data-vv-name="membLoginBanDuration" :data-vv-as="labels.membLoginBanDuration" v-validate="'required|numeric|max_value:99999999|min_value:0'"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions class="ma-2">
              <v-btn color="primary" :loading="loading" @click.prevent="doMembUpdateCheck" type="submit">
                Update
                <v-icon right>mdi-content-save</v-icon>
              </v-btn>
            </v-card-actions>
          </v-tab-item>
        </v-tabs>
      </v-card>
    </form>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import MessageMixin from '@/mixins/message'
export default {
  data() {
    return {
      labels: {
        usr2FA: 'Enable Two-Factor Authentication?',
        usrDormant: 'Max Dormant Period (days)',
        usrLoginAttempt: 'Max Failed Sign In Attempts',
        usrLoginBanDuration: 'Time Ban for Failed Attempts (mins)',
        membDormant: 'Max Dormant Period (days)',
        membLoginAttempt: 'Max Failed Sign In Attempts',
        membLoginBanDuration: 'Time Ban for Failed Attempts (mins)'
      },
      acctForm: {
        usr2FA: false,
        usrDormant: null,
        usrLoginAttempt: null,
        usrLoginBanDuration: null
      },
      memberAcctForm: {
        membDormant: null,
        membLoginAttempt: null,
        membLoginBanDuration: null
      },
      loading: false,
      menu: {},
      tabMenu: null
    }
  },
  methods: {
    async init() {
      const apiUrl = this.$store.state.adminUser.security.menu.acctSettings
      if (apiUrl) {
        try {
          this.loading = true
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          if (data) {
            this.acctForm.usr2FA = data.usr2FA
            this.acctForm.usrDormant = data.usrDormant
            this.acctForm.usrLoginAttempt = data.usrLoginAttempt
            this.acctForm.usrLoginBanDuration = data.usrLoginBanDuration

            this.memberAcctForm.membDormant = data.membDormant
            this.memberAcctForm.membLoginAttempt = data.membLoginAttempt
            this.memberAcctForm.membLoginBanDuration = data.membLoginBanDuration

            // Extract the menu
            this.menu = extractMenu(result.data._links)
          }
          this.loading = false
        } catch (error) {
          this.loading = false
          throw error
        }
      } else {
        throw new Error('Invalid API URL')
      }
    },
    doUpdateCheck() {
      this.resetMessages()
      this.$validator.validateAll('acctForm').then(result => {
        if (result) {
          this.doUpdate()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doMembUpdateCheck() {
      this.resetMessages()
      this.$validator.validateAll('memberAcctForm').then(result => {
        if (result) {
          this.doMembUpdate()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doUpdate() {
      const apiURI = this.menu.updateUsers
      if (apiURI) {
        this.loading = true
        try {
          const result = await this.$http.put(apiURI, this.acctForm)
          this.message(result.data)
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    async doMembUpdate() {
      const apiURI = this.menu.updateMembers
      if (apiURI) {
        this.loading = true
        try {
          const result = await this.$http.put(apiURI, this.memberAcctForm)
          this.message(result.data)
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style>
</style>
